import { Map } from 'immutable';
import { pathSubscription, regSub, subscribe } from 'nike-re-framejs';
import { DATA, EMPTY, PENDING } from '@/common/dataState';
import { denormalizeSportEventId } from '@/nikeone/domain/sportevent';

export const ticketMinimal$ = hash => pathSubscription(['ticketus', 'minimal', hash]);
export const ticketDetail$ = hash => pathSubscription(['ticketus', 'detail', hash]);
export const ticketDetailBets = hash => pathSubscription(['ticketus', 'detail', hash, 'bets']);

regSub('ticketus/scoreboard/is-open', (db, [_, eventId]) => {
    return db.getIn(['scoreboard', 'events'], Map()).has(String(denormalizeSportEventId(eventId)));
});

regSub('ticketus/scoreboard/is-loaded', (db, [_, eventId]) => {
    eventId = String(denormalizeSportEventId(eventId));
    const event = db.getIn(['scoreboard', 'events', eventId]);
    if (event === null) {
        return EMPTY;
    }
    if (event === undefined) {
        return PENDING;
    }

    return DATA;
});

regSub('ticketus/detail', db => db.getIn(['ticketus', 'detail']));

regSub(
    'ticketus/detailOrOverview/ticket',
    () => [subscribe(['ticketus/detail']), subscribe(['ticketus/overview/list'])],
    ([detailList, overviewList], [_, hash]) => {
        let detail = detailList && detailList.get(hash);
        if (detail && !detail.get('error')) {
            return detail;
        }
        return overviewList && overviewList.get('data') && overviewList.get('data').find(t => t.get('hash') === hash);
    }
);
